import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

// Note: not setting baseURL here for we may use many diff urls
// only good to have one createApi. Throws merge error if you attempt two have multiple createApis
// Therefore putting baseURL inside each ineject endpoint file. See migration.js or employee.js
// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  baseQuery: fetchBaseQuery({
    reducerPath: 'api',
    prepareHeaders: (headers, { getState }) => {
      const { token } = getState().user ?? {};
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 60,
  endpoints: () => ({}),
  tagTypes: ['hub', 'login', 'master-data', 'POST', 'dashboard'],
});

export const catchApiError = (err) => {
  if (err.response && err.response.status === 401) {
    window.top.postMessage('expired-jwt', '*');
  }
};

export const userParam = (user) => {
  const { usingLeadershipRole, site } = user ?? {};
  const path = usingLeadershipRole ? 'users' : `${site}`;
  console.log('User Path', usingLeadershipRole, path);
  return path;
};
